module.exports = __webpack_public_path__ + "static/media/Group 37392.c058deb4.png";